export var APP_STORE = {
    LOADED: 'appStore/loaded',
    SET_LOADED: 'appStore/setLoaded',
    GET_WAYPOINTS: 'appStore/getWaypoints',
    SET_WAYPOINT: 'appStore/setCategoryWaypoint',
    GET_BASE: 'appStore/getBaseLocation',
    SET_BASE: 'appStore/setBaseLocation',
    GET_DETAILS: 'appStore/details',
    SET_DETAILS: 'appStore/setDetails',
    GET_DEBUG: 'appStore/debugMode',
    SET_DEBUG: 'appStore/setDebugMode',
    GET_SHOW_GREETING_MOBILE: 'appStore/showGreetingMobile',
    SET_SHOW_GREETING_MOBILE: 'appStore/setShowGreetingMobile',
    GET_FEATURE: 'appStore/getFeatureFlag',
    SET_FEATURE: 'appStore/setFeatureFlag',
    GET_FLOWS: 'appStore/getFlows',
    GET_FLOW: 'appStore/getFlow',
    SET_FLOW: 'appStore/setFlow',
    GET_FLOW_STEP: 'appStore/getFlowStep',
    SET_FLOW_STEP: 'appStore/setFlowStep',
    GET_COMPLETED_ROUTE: 'appStore/getCompletedRoute',
    SET_COMPLETED_ROUTE: 'appStore/setCompletedRoute',
    GET_BACK_ROUTE: 'appStore/getBackRoute',
    SET_BACK_ROUTE: 'appStore/setBackRoute',
    GET_GMAP_API: 'appStore/getGmapAPIKey',
    SET_GMAP_API: 'appStore/setGmapAPIKey',
    GET_NEW_STORE_WELCOME: 'appStore/showNewStoreWelcome',
    SET_NEW_STORE_WELCOME: 'appStore/setShowNewStoreWelcome',
    GET_STORE_DEEP_LINK: 'appStore/getStoreDeepLink',
    SET_STORE_DEEP_LINK: 'appStore/setStoreDeepLink',
    GET_REFRESH_KEY: 'appStore/getRefreshKey',
    UPDATE_REFRESH_KEY: 'appStore/updateRefreshKey',
    GET_ONLINE_STATUS: 'appStore/getOnlineStatus',
    SET_ONLINE_STATUS: 'appStore/setOnlineStatus',
};
export var HEADER = {
    GET_TITLE: 'headerStore/getTitle',
    SET_TITLE: 'headerStore/setTitle',
    GET_ITEMS: 'headerStore/getItems',
    SET_ITEMS: 'headerStore/setItems',
    GET_HEADER_HEIGHT: 'headerStore/getHeaderHeight',
    SET_HEADER_HEIGHT: 'headerStore/setHeaderHeight',
};
export var MENU_ITEMS = {
    GET_ALL: 'items/allItems',
    GET_MAP: 'items/getMap',
    HAS_ITEMS: 'items/hasItems',
    FETCH_ALL: 'items/fetchAllItems',
    SET_ALL: 'items/setItems',
    GET_ITEM: 'items/getItem',
    GET_SECTION: 'items/getSection',
    GET_BY_PARENT_ASSET_ID: 'items/getItemByParentAssetId',
    SET_MENU_ID: 'items/setMenuId',
    GET_MENU_ID: 'items/getMenuId',
};
export var MENU_OPTIONS = {
    GET_ALL: 'itemOptions/allOptions',
    GET_CHOICES: 'itemOptions/choicesForOption',
    GET_FILTERED_CHOICES: 'itemOptions/filteredChoicesForOption',
    GET_REQUIRED: 'itemOptions/allRequired',
    GET_OPTIONAL: 'itemOptions/allOptional',
    GET_ITEM_ALL: 'itemOptions/allForItem',
    GET_ITEM_REQUIRED: 'itemOptions/requiredForItem',
    GET_ITEM_OPTIONAL: 'itemOptions/optionalForItem',
    SET_ALL: 'itemOptions/setOptions',
    FETCH_ALL: 'itemOptions/fetchOptions',
    GET_OPTION: 'itemOptions/getOption',
};
export var MENU_OPTION_EXCEPTIONS = {
    GET_ALL: 'itemOptionExceptions/all',
    GET_FOR_ITEM: 'itemOptionExceptions/forItem',
    SET_ALL: 'itemOptionExceptions/setOptionExceptions',
};
export var CART = {
    ITEM_COUNT: 'cart/itemCount',
    LINE_ITEM_COUNT: 'cart/lineItemCount',
    ITEMS: 'cart/items',
    NON_BUNDLE_ITEMS: 'cart/nonBundleItems',
    COUPON_ITEMS: 'cart/couponItems',
    PRICE: 'cart/price',
    GET_ITEM_PRICE: 'cart/itemPrice',
    ADD_ITEM: 'cart/addItem',
    REMOVE_ITEM: 'cart/removeItem',
    UPDATE_ITEM: 'cart/updateItem',
    GET_CURRENT_ITEM: 'cart/currentItem',
    SET_CURRENT_ITEM: 'cart/setCurrentItem',
    INCREMENT_CURRENT: 'cart/incrementQuantity',
    DECREMENT_CURRENT: 'cart/decrementQuantity',
    INCREMENT_ITEM: 'cart/incrementItemQuantity',
    DECREMENT_ITEM: 'cart/decrementItemQuantity',
    ITEM_QUANTITY: 'cart/itemQuantity',
    SET_ITEM_QUANTITY: 'cart/setItemQuantity',
    SET_CURRENT_ITEM_QUANTITY: 'cart/setCurrentItemQuantity',
    ADD_RECENT_ORDER: 'cart/addRecentOrder',
    SET_ITEMS: 'cart/setCart',
    CLEAR_CART: 'cart/clearCart',
    GET_CHECKOUT_TOTAL: 'cart/checkoutTotal',
    SET_TOTALS: 'cart/setTotals',
    GET_TOTALS: 'cart/getTotals',
    SET_TIP: 'cart/setTip',
    SET_COUPON: 'cart/setCoupon',
    GET_COUPON: 'cart/getCoupon',
    SET_APPLY_OFFER: 'cart/setApplyOffer',
    GET_APPLY_OFFER: 'cart/getApplyOffer',
    GET_TRANSACTION_ID: 'cart/getTransactionId',
    SET_TRANSACTION_ID: 'cart/setTransactionId'
};
export var CART_OPTION = {
    // OPTION
    GET_ALL: 'cartOptions/allOptions',
    CLEAR_ALL: 'cartOptions/clearOptions',
    GET_REQUIRED: 'cartOptions/allRequired',
    GET_OPTIONAL: 'cartOptions/allOptional',
    ADD_OPTION: 'cartOptions/addOption',
    SET_OPTIONS: 'cartOptions/setOptions',
    GET_OPTION_SIBLING: 'cartOptions/getSiblingOptions',
    // CHOICE
    SET_CHOICE: 'cartOptions/setChoiceForOption',
    GET_CHOICES: 'cartOptions/getChoicesForOption',
    GET_CHOICE_STATE: 'cartOptions/getChoiceStateForOption',
    GET_CHOICE_QUANTITY: 'cartOptions/getChoiceQuantity',
    GET_CHOICE_SIBLING: 'cartOptions/getChoiceSibling',
    ADD_CHOICE: 'cartOptions/addChoice',
    REMOVE_CHOICE: 'cartOptions/removeChoice',
    UPDATE_CHOICE: 'cartOptions/updateChoice',
    SET_CHOICE_QUANTITY: 'cartOptions/setChoiceQuantity',
    SET_CHOICE_SIBLING: 'cartOptions/setChoiceSibling',
    // BOTH
    LIST_ALL: 'cartOptions/getListedChoices',
    VALIDATE_OPTIONS: 'cartOptions/validOptions',
    SIBLING_OPTION_CHOICES: 'cartOptions/getSiblingOptionChoices',
};
export var TRACKER = {
    GET_ACTIVE: 'tracker/getActive',
    SET_ACTIVE: 'tracker/setActive',
    GET_POSITION: 'tracker/getPosition',
    SET_POSITION: 'tracker/setPosition',
    SET_PREVIOUS_POSITION: 'tracker/setPreviousPosition',
    GET_PREVIOUS_POSITION: 'tracker/getPreviousPosition',
};
export var ORDER = {
    GET_ORDER: 'order/getOrder',
    SET_ORDER: 'order/setOrder',
    GET_DELAY_TIME: 'order/getDelay',
    SET_DELAY_TIME: 'order/setDelay',
    GET_DELAY_TYPE: 'order/getDelayType',
    SET_DELAY_TYPE: 'order/setDelayType',
};
export var BUNDLE = {
    GET_BUNDLE: 'bundle/currentBundle',
    SET_BUNDLE: 'bundle/setCurrentBundle',
    ITEM: 'bundle/itemBundle',
    SET_ITEM: 'bundle/setItemBundle',
    SET_ITEMS: 'bundle/setItems',
    GET_GROUPS: 'bundle/getGroups',
    SET_GROUPS: 'bundle/setGroups',
    OPTIONS_FOR_ITEM: 'bundle/optionsForItem',
    CLEAR_OPTIONS: 'bundle/clearItemOptions',
    SET_CHOICES_FOR_OPTION: 'bundle/setChoicesForOption',
    GET_CHOICES_FOR_OPTION: 'bundle/getChoicesForOption',
    ITEM_IN_GROUP: 'bundle/itemSelectedInGroup',
    SET_CURRENT_GROUP: 'bundle/setCurrentGroup',
    GET_CURRENT_GROUP: 'bundle/getCurrentGroup',
    GET_ITEMS: 'bundle/items',
    ADD_ITEM: 'bundle/addItem',
    CLEAR_ITEMS: 'bundle/clearItems',
    CLEAR_GROUP: 'bundle/clearGroup',
    GROUP_REQUIREMENTS: 'bundle/groupRequirementsMet',
    ALL_REQUIREMENTS: 'bundle/allRequirementsMet',
    GET_TOTAL: 'bundle/total',
};
export var ACCOUNT = {
    ADD_ADDRESS: "account/addAddress",
    ADD_PAYMENT: "account/addPayment",
    DELETE_PAYMENT: "account/deletePayment",
    DELETE_ADDRESS: "account/deleteAddress",
    EDIT_ADDRESS: "account/editAddress",
    GET_ADDRESSES: 'account/getAddresses',
    GET_CUSTOMER: 'account/getCustomer',
    GET_LOGGED_IN: 'account/getLoggedIn',
    GET_LOYALTY: "account/getLoyaltyPoints",
    SET_CUSTOMER: 'account/setCustomer',
    SET_LOGGED_IN: 'account/setLoggedIn',
    UPDATE_CUSTOMER: 'account/updateCustomer',
    GET_OFFERS: 'account/getOffers',
    SET_OFFERS: 'account/setOffers',
    APPLY_OFFER: 'account/applyOffer',
    CANCEL_OFFER: 'account/cancelOffer',
    GET_GUEST_ADDRESS: 'account/getGuestAddress',
    SET_GUEST_ADDRESS: 'account/setGuestAddress',
    GET_GUEST_PHONE: 'account/getGuestPhone',
    SET_GUEST_PHONE: 'account/setGuestPhone',
    GET_GUEST_EMAIL: 'account/getGuestEmail',
    SET_GUEST_EMAIL: 'account/setGuestEmail',
    GET_GUEST_NAME: 'account/getGuestName',
    SET_GUEST_NAME: 'account/setGuestName',
    SET_SELECTED_ADDRESS: 'account/setSelectedAddressId',
    GET_SELECTED_ADDRESS: 'account/getSelectedAddressId',
    SET_SELECTED_PAYMENT: 'account/setSelectedPaymentId',
    GET_SELECTED_PAYMENT: 'account/getSelectedPaymentId',
    SET_IS_NEW_ACCOUNT: 'account/setIsNewAccount',
    GET_IS_NEW_ACCOUNT: 'account/getIsNewAccount',
};
export var CATEGORY = {
    SET_ALL: 'category/setCategories',
    GET_ALL: 'category/all',
    GET_AVAILABLE: 'category/allAvailable',
    HAS_CATEGORIES: 'category/hasCategories',
    GET_CATEGORY: 'category/getCategory',
    GET_NAME: 'category/getName',
    FETCH_ALL: 'category/fetchAll',
    FIST_ITEM: 'category/firstItem',
    GET_CURRENT: 'category/currentCategory',
    SET_CURRENT: 'category/setCurrentCategory',
    GET_SECTION_ITEMS: 'category/section',
    GET_CATEGORY_FOR_ITEM: 'category/categoryForItem',
};
export var RECENT_ORDERS = {
    GET_RECENT_ORDERS: 'recentOrders/getRecentOrders',
    GET_RECENT_ORDER_BY_ID: 'recentOrders/getRecentOrderById',
    HAS_RECENT_ORDERS: 'recentOrders/hasRecentOrders',
    SET_RECENT_ORDERS: 'recentOrders/setRecentOrders',
    SET_ACTIVE_ORDER: 'recentOrders/setActiveOrder',
    GET_ACTIVE_ORDER: 'recentOrders/getActiveOrder'
};
// TODO change this store name or break apart ACCOUNT/CHECKOUT/PAYMENT/GUEST etc
export var ACCOUNT_CHECKOUT = {
    SET_SERVICE_TYPE: 'accountCheckout/setServiceType',
    SET_DELIVERY_ADDRESS: 'accountCheckout/setDeliveryAddress',
    SET_PAYMENT_METHOD: 'accountCheckout/setPaymentMethod',
    SET_ORDER_TIME: 'accountCheckout/setOrderTime',
    GET_SERVICE_TYPE: 'accountCheckout/getServiceType',
    GET_DELIVERY_ADDRESS: 'accountCheckout/getDeliveryAddress',
    GET_PAYMENT_METHOD: 'accountCheckout/getPaymentMethod',
    GET_PREORDER: 'accountCheckout/getPreorder',
    GET_ORDER_TIME: 'accountCheckout/getOrderTime',
    SET_PREORDER: 'accountCheckout/setPreorder',
    GET_ORDER_IN_FLIGHT: 'accountCheckout/getOrderInFlight',
    SET_ORDER_IN_FLIGHT: 'accountCheckout/setOrderInFlight',
    GET_USER_INSTRUCTIONS: 'accountCheckout/getUserInstructions',
    SET_USER_INSTRUCTIONS: 'accountCheckout/setUserInstructions',
    GET_USER_SET_SERVICE_TYPE: 'accountCheckout/getUserSetServiceType',
    SET_USER_SET_SERVICE_TYPE: 'accountCheckout/setUserSetServiceType',
    GET_IS_GUEST: 'accountCheckout/getIsGuest',
    SET_IS_GUEST: 'accountCheckout/setIsGuest',
    GET_GUEST_ID: 'accountCheckout/getGuestId',
    SET_GUEST_ID: 'accountCheckout/setGuestId',
    GET_OFFER_FLAG: 'accountCheckout/getOfferFlag',
    SET_OFFER_FLAG: 'accountCheckout/setOfferFlag',
    GET_LEAVE_AT_DOOR: 'accountCheckout/getLeaveAtDoor',
    SET_LEAVE_AT_DOOR: 'accountCheckout/setLeaveAtDoor',
};
export var LOCATION = {
    SET_LOCATION: "location/setLocation",
    GET_LOCATION: "location/getLocation",
    GET_LOCATIONS: "location/getLoadedLocations",
    SET_LOCATIONS: "location/setLocations",
    GET_ALL_COORDINATES: 'location/getLocationCoordinates',
    GET_MIN_DELIVERY: 'location/getMinimumDelivery',
    SET_MIN_DELIVERY: 'location/setMinimumDelivery',
};
export var FRANCHISOR = {
    GET_FRANCHISOR: "franchisor/getFranchisor",
    SET_FRANCHISOR: "franchisor/setFranchisor",
};
export var UPSELL = {
    GET_ITEMS: 'upsell/allItems',
    SET_ITEMS: 'upsell/setItems',
    SHOW_UPSELL: 'upsell/showUpsell',
    OFF: 'upsell/setShowUpsellOff',
    ON: 'upsell/setShowUpsellOn',
};
export var DISCOUNT = {
    GET_FOR_ITEM: 'discount/discountForItem',
    SET_FOR_ITEM: 'discount/setDiscountForItem',
    SET_BASE_PRICE_FOR_ITEM: 'discount/setBasePriceForItem',
    GET_BASE_PRICE_FOR_ITEM: 'discount/getBasePriceForItem',
    GET_DISCOUNTS: 'discount/getDiscounts',
    ADD_DISCOUNT: 'discount/addDiscount',
    CURRENT_DISCOUNTED_PRICE: 'discount/currentDiscountedPrice',
    SET_CURRENT_DISCOUNTED_PRICE: 'discount/setCurrentDiscountedPrice',
    CLEAR_DISCOUNTS: 'discount/clearDiscounts',
};
export var LAYOUT = {
    GET_ROUTE_LEVEL: 'layout/getRouteLevelLayout',
    SET_ROUTE_LEVEL: 'layout/setRouteLevelLayout',
};
export var STORAGE_KEYS = {
    cartKeyName: 'USER_CART',
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/defs.ts
// module id = Xbdx
// module chunks = 18